import z from "zod";

export const placementOverrideSchema = z.object({
  frameName: z.string(),
  sizeType: z.string(),
  tssPlacementId: z.string(),
});

export type PlacementOverrideSchema = z.infer<typeof placementOverrideSchema>;
